import { createReducer, on } from "@ngrx/store";
import { initializeUserProfileState, UserProfileState } from "./user-profile.state";
import { GetOwnUserProfile, GetOwnUserProfileError, GetOwnUserProfileSuccess, GetUserProfile, GetUserProfileError, GetUserProfileSuccess, ResetOwnUserProfile, SetUserProfile, UserHasAccessToLearner, UserHasAccessToLearnerError, UserHasAccessToLearnerSuccess } from "./user-profile.actions";
import { ADMIN_ROLES, Roles } from "src/app/constants/Roles";
import { adminInformationHeader, learnerInformationHeader, tutorInformationHeader } from "src/app/_models/InformationHeader";

export const UserProfileReducer = createReducer(
  initializeUserProfileState,
  on(GetOwnUserProfile, (state): UserProfileState => {
    return {
      ...state,
      loading: true
    }
  }),
  on(GetOwnUserProfileSuccess, (state, action): UserProfileState => {
    return {
      ...state,
      loading: false,
      userProfile: action.userProfile,
      informationHeader: action.userProfile?.roleId == Roles.Learner ? learnerInformationHeader :
        action.userProfile?.roleId == Roles.Tutor ? tutorInformationHeader :
          ADMIN_ROLES.includes(action.userProfile?.roleId) ? adminInformationHeader :
            state.informationHeader
    }
  }),
  on(GetOwnUserProfileError, (state, action): UserProfileState => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  }),
  on(ResetOwnUserProfile, (state): UserProfileState => {
    return{
      ...state,
      loading: false,
      userProfile: null,
      error: null
    }
  }),
  on(GetUserProfile, (state): UserProfileState => {
    return{
      ...state,
      loading: true,
      profile: null
    }
  }),
  on(GetUserProfileSuccess, (state, action): UserProfileState => {
    return{
      ...state,
      loading: false,
      profile: action.result
    }
  }),
  on(GetUserProfileError, (state, action): UserProfileState => {
    return{
      ...state,
      loading: false,
      error: action.error
    }
  }),
  on(UserHasAccessToLearner, (state): UserProfileState => {
    return  {
      ...state,
      hasAccessToLearner: null,
      hasAccessToLearnerLoader: true,
      hasAccessToLearnerError: null,
    }
  }),
  on(UserHasAccessToLearnerSuccess, (state, action): UserProfileState => {
    return  {
      ...state,
      hasAccessToLearner: action.result,
      hasAccessToLearnerLoader: false,
      hasAccessToLearnerError: null,
    }
  }),
  on(UserHasAccessToLearnerError, (state, action): UserProfileState => {
    return  {
      ...state,
      hasAccessToLearnerLoader: false,
      hasAccessToLearnerError: action.error,
    }
  }),
  on(SetUserProfile, (state, action): UserProfileState => {
    return {
      ...state,
      userProfile: action.userProfile,
    }
  }),
);